<template>
  <v-dialog
    v-model="show"
    width="60vw"
    :fullscreen="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly"
    scrollable
    persistent
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="text-h6">Validaciones</span>
          </v-col>
          <v-col cols="12" v-if="validationSelected && validationUpdate">
            <span class="text-body-1 ml-0">
              {{ materialSelected.serial }} - {{ validationSelected.text }} -
              {{ getStatus(validationUpdate.status) }}
            </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="validationSelected"
                :items="validations"
                dense
                no-data-text="Validación no disponible"
                label="Seleciona validacion"
                outlined
                clearable
                :loading="isLoading"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>
          <div v-if="!loadValidation">
            <div v-if="validationUpdate">
              <v-form ref="formDate" lazy-validation>
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      v-model="validationUpdate.analysisQualityDate"
                      type="date"
                      dense
                      outlined
                      label="Fecha de análisis Calidad"
                      :disabled="validationUpdate.isReadyToValidate"
                      :rules="validation('fecha', 'F')"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="!validationUpdate.isReadyToValidate">
                    <v-btn
                      color="primary"
                      rounded
                      :loading="isSaving"
                      @click="saveDate"
                    >
                      <v-icon> mdi-content-save </v-icon>
                      Guardar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>

              <v-row v-if="validationUpdate.isReadyToValidate">
                <v-col>
                  <v-expansion-panels accordion v-model="panels">
                    <!-- organoleptic characteristics -->
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        :disable-icon-rotate="validationUpdate.isReadyOR"
                      >
                        Características organolépticas
                        <template
                          v-slot:actions
                          v-if="validationUpdate.isReadyOR"
                        >
                          <v-icon color="teal"> mdi-check </v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-form
                          ref="formOrganolepticCharacteristics"
                          lazy-validation
                        >
                          <v-row>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-autocomplete
                                v-model="validationUpdate.isForeignMatter"
                                outlined
                                label="Materia extraña"
                                dense
                                :items="foreignMatter"
                                return-object
                                clearable
                                :rules="validation('materia extraña', 'F')"
                                :disabled="
                                  validationUpdate.isReadyOR != undefined
                                "
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.appearance"
                                type="text"
                                outlined
                                label="Apariencia"
                                dense
                                clearable
                                :rules="validation('apariencia', 'F')"
                                :disabled="
                                  validationUpdate.isReadyOR != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.color"
                                type="text"
                                outlined
                                label="Color"
                                dense
                                clearable
                                :rules="validation('color')"
                                :disabled="
                                  validationUpdate.isReadyOR != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.smell"
                                type="text"
                                outlined
                                label="Olor"
                                dense
                                clearable
                                :rules="validation('olor')"
                                :disabled="
                                  validationUpdate.isReadyOR != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.texture"
                                type="text"
                                outlined
                                label="Textura"
                                dense
                                clearable
                                :rules="validation('textura', 'F')"
                                :disabled="
                                  validationUpdate.isReadyOR != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-autocomplete
                                v-model="
                                  validationUpdate.successfulOrganolepticCharacteristics
                                "
                                outlined
                                label="Validación proceso"
                                dense
                                :items="isSuccess"
                                return-object
                                clearable
                                :rules="validation('validación', 'F')"
                                :disabled="
                                  validationUpdate.isReadyOR != undefined
                                "
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row
                            align="center"
                            justify="end"
                            v-if="validationUpdate.isReadyOR == undefined"
                          >
                            <v-col cols="12" xl="4" lg="4">
                              <v-btn
                                color="gray"
                                dark
                                block
                                @click="saveORData"
                                :loading="isLoadingORSave"
                              >
                                Guardar
                              </v-btn>
                            </v-col>
                            <v-col cols="12" xl="4" lg="4">
                              <v-btn
                                color="primary"
                                dark
                                block
                                :loading="isLoadinfORFinish"
                                @click="showConfirmationOR = true"
                                >Validar
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Microbiological analysis -->
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        v-if="validationUpdate.isReadyOR == true"
                        :disable-icon-rotate="validationUpdate.isReadyMB"
                      >
                        Análisis microbiológico
                        <template
                          v-slot:actions
                          v-if="validationUpdate.isReadyMB"
                        >
                          <v-icon color="teal"> mdi-check </v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content
                        v-if="validationUpdate.isReadyOR == true"
                      >
                        <v-form
                          ref="formMicrobiologicalAnalysis"
                          lazy-validation
                        >
                          <v-row>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.fungiAndYeast"
                                type="number"
                                outlined
                                label="Hongos y levaduras"
                                dense
                                clearable
                                :rules="validationNumberMin()"
                                :disabled="
                                  validationUpdate.isReadyMB != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.coliforms"
                                type="number"
                                outlined
                                label="Coliformes totales"
                                dense
                                clearable
                                :rules="validationNumberMin()"
                                :disabled="
                                  validationUpdate.isReadyMB != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.facultativeAerobes"
                                type="number"
                                outlined
                                label="Aerobios facultativos"
                                dense
                                clearable
                                :rules="validationNumberMin()"
                                :disabled="
                                  validationUpdate.isReadyMB != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-autocomplete
                                v-model="
                                  validationUpdate.successfulMicrobiologicalAnalysis
                                "
                                outlined
                                label="Validación proceso"
                                dense
                                :items="isSuccess"
                                return-object
                                clearable
                                :rules="validation('validación', 'F')"
                                :disabled="
                                  validationUpdate.isReadyMB != undefined
                                "
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-textarea
                                v-model="
                                  validationUpdate.microbiologicalObservations
                                "
                                outlined
                                name="input-7-4"
                                label="Observaciones"
                                dense
                                clearable
                                :disabled="
                                  validationUpdate.isReadyMB != undefined
                                "
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row
                            align="center"
                            justify="end"
                            v-if="validationUpdate.isReadyMB == undefined"
                          >
                            <v-col cols="12" xl="4" lg="4">
                              <v-btn
                                color="gray"
                                dark
                                block
                                @click="saveMBData"
                                :loading="isLoadingMBSave"
                              >
                                Guardar
                              </v-btn>
                            </v-col>
                            <v-col cols="12" xl="4" lg="4">
                              <v-btn
                                color="primary"
                                dark
                                block
                                :loading="isLoadingMBFinish"
                                @click="showConfirmationMB = true"
                                >Validar
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Physicochemical analysis -->
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        v-if="validationUpdate.isReadyMB == true"
                        :disable-icon-rotate="validationUpdate.isReadyPCT"
                      >
                        Análisis fisicoquímico
                        <template
                          v-slot:actions
                          v-if="validationUpdate.isReadyPCT"
                        >
                          <v-icon color="teal"> mdi-check </v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content
                        v-if="validationUpdate.isReadyMB == true"
                      >
                        <v-form
                          ref="formPhysicochemicalAnalysis"
                          lazy-validation
                        >
                          <v-row>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.density"
                                type="text"
                                outlined
                                label="Densidad"
                                dense
                                clearable
                                :rules="validation('densidad', 'F')"
                                :disabled="
                                  validationUpdate.isReadyPCT != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.viscosity"
                                type="text"
                                outlined
                                label="Viscosidad"
                                dense
                                clearable
                                :rules="validation('viscosidad', 'F')"
                                :disabled="
                                  validationUpdate.isReadyPCT != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-text-field
                                v-model="validationUpdate.ph"
                                type="number"
                                outlined
                                label="pH"
                                dense
                                clearable
                                :rules="validation('pH', 'M')"
                                :disabled="
                                  validationUpdate.isReadyPCT != undefined
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-autocomplete
                                v-model="validationUpdate.particleSize"
                                type="text"
                                outlined
                                label="Tamaño de particulas (malla de 755 micras)"
                                dense
                                return-object
                                :items="particleSizeItems"
                                clearable
                                :rules="validation('particula', 'M')"
                                :disabled="
                                  validationUpdate.isReadyPCT != undefined
                                "
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-textarea
                                v-model="
                                  validationUpdate.physicochemicalObservations
                                "
                                outlined
                                name="input-7-4"
                                label="Observaciones"
                                dense
                                clearable
                                :disabled="
                                  validationUpdate.isReadyPCT != undefined
                                "
                              ></v-textarea>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-autocomplete
                                v-model="
                                  validationUpdate.successfulPhysicochemicalAnalysis
                                "
                                outlined
                                label="Validación proceso"
                                dense
                                :items="isSuccess"
                                return-object
                                clearable
                                :rules="validation('validación', 'F')"
                                :disabled="
                                  validationUpdate.isReadyPCT != undefined
                                "
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row
                            align="center"
                            justify="end"
                            v-if="validationUpdate.isReadyPCT == undefined"
                          >
                            <v-col cols="12" xl="4" lg="4">
                              <v-btn
                                color="gray"
                                dark
                                block
                                @click="savePCTData"
                                :loading="isLoadingPCTSave"
                              >
                                Guardar
                              </v-btn>
                            </v-col>
                            <v-col cols="12" xl="4" lg="4">
                              <v-btn
                                color="primary"
                                dark
                                block
                                :loading="isLoadingPCTFinish"
                                @click="showConfirmationPCT = true"
                                >Validar
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- PM Compliance and Acceptance -->
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        v-if="validationUpdate.isReadyPCT == true"
                        :disable-icon-rotate="validationUpdate.isReadyPM"
                      >
                        Conformidad y Aceptación de MP
                        <template
                          v-slot:actions
                          v-if="validationUpdate.isReadyPM"
                        >
                          <v-icon color="teal"> mdi-check </v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content
                        v-if="validationUpdate.isReadyPCT == true"
                      >
                        <v-form
                          ref="formPMComplianceAcceptance"
                          lazy-validation
                        >
                          <v-row>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-autocomplete
                                v-model="
                                  validationUpdate.successfulMaterialQuality
                                "
                                outlined
                                label="Validación calidad"
                                dense
                                :items="isSuccess"
                                return-object
                                clearable
                                :rules="validation('validación', 'F')"
                                :disabled="
                                  validationUpdate.isReadyPM != undefined
                                "
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-autocomplete
                                v-model="
                                  validationUpdate.successfulMaterialStock
                                "
                                outlined
                                label="Validación almacén"
                                dense
                                :items="isSuccess"
                                return-object
                                clearable
                                :rules="validation('validación', 'F')"
                                :disabled="
                                  validationUpdate.isReadyPM != undefined
                                "
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                              <v-textarea
                                v-model="validationUpdate.observations"
                                outlined
                                name="input-7-4"
                                label="Observaciones"
                                dense
                                clearable
                                :disabled="
                                  validationUpdate.isReadyPM != undefined
                                "
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row
                            align="center"
                            justify="end"
                            v-if="validationUpdate.isReadyPM == undefined"
                          >
                            <v-col cols="12" xl="4" lg="4">
                              <v-btn
                                color="gray"
                                dark
                                block
                                @click="savePMData"
                                :loading="isLoadingPMSave"
                              >
                                Guardar
                              </v-btn>
                            </v-col>
                            <v-col cols="12" xl="4" lg="4">
                              <v-btn
                                color="warning"
                                dark
                                block
                                :loading="isLoadingPMFinish"
                                @click="showConfirmationPM = true"
                                >Finalizar
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="12"
                              xl="4"
                              lg="4"
                              v-if="
                                validationUpdate.successfulMaterialQuality &&
                                validationUpdate.successfulMaterialStock &&
                                validationUpdate.successfulMaterialQuality
                                  .value &&
                                validationUpdate.successfulMaterialStock.value
                              "
                            >
                              <v-btn
                                color="primary"
                                dark
                                block
                                :loading="isLoadingNewValidation"
                                @click="showConfirmationNewValidation = true"
                                >Generar nueva validación
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </div>
          </div>
          <div v-else>
            <v-skeleton-loader
              boilerplate
              type="list-item-avatar"
            ></v-skeleton-loader>
            <v-skeleton-loader
              boilerplate
              type="list-item-avatar"
            ></v-skeleton-loader>
            <v-skeleton-loader
              boilerplate
              type="list-item-avatar"
            ></v-skeleton-loader>
            <v-skeleton-loader
              boilerplate
              type="list-item-avatar"
            ></v-skeleton-loader>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" block @click="closeModal" dark rounded
                >Cerrar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <ConfirmationOR
      v-model="showConfirmationOR"
      @confirmation="finishORData"
      :title="'¿Estás seguro que quieres validar características organolépticas?'"
    />
    <ConfirmationMB
      v-model="showConfirmationMB"
      @confirmation="finishMBData"
      :title="'¿Estás seguro que quieres validar análisis microbiológico?'"
    />
    <ConfirmationPCT
      v-model="showConfirmationPCT"
      @confirmation="finishPCTData"
      :title="'¿Estás seguro que quieres validar análisis fisicoquímico?'"
    />
    <ConfirmationPM
      v-model="showConfirmationPM"
      @confirmation="finishPMData"
      :title="'¿Estás seguro que quieres validar conformidad y Aceptación de MP?'"
    />
    <ConfirmationNewValidation
      v-model="showConfirmationNewValidation"
      @confirmation="generateNewValidation"
      :title="'¿Estás seguro que quieres iniciar una nueva validación?'"
    />
  </v-dialog>
</template>

<script>
// Validations
import {
  requiredFValidation,
  requiredValidation,
  numberValidation,
} from "@/helpers/validations.js";
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
// components
import ConfirmationOR from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmationMB from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmationPCT from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmationPM from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmationNewValidation from "@/components/utils/GenericConfirmationModal.vue";
export default {
  components: {
    ConfirmationOR,
    ConfirmationMB,
    ConfirmationPCT,
    ConfirmationPM,
    ConfirmationNewValidation,
  },
  data: () => ({
    validations: [],
    validationSelected: null,
    validationUpdate: null,
    isLoading: false,
    panels: null,
    loadValidation: false,
    isSaving: false,

    foreignMatter: [
      {
        text: "Presente",
        value: true,
      },
      {
        text: "No presente",
        value: false,
      },
    ],
    isSuccess: [
      {
        text: "Cumple",
        value: true,
      },
      {
        text: "No cumple",
        value: false,
      },
    ],
    particleSizeItems: [
      {
        text: "Adecuado",
        value: "appropriate",
      },
      {
        text: "No adecuado",
        value: "not_appropriate",
      },
      {
        text: "No aplica",
        value: "not_apply",
      },
    ],
    isLoadingORSave: false,
    isLoadinfORFinish: false,
    showConfirmationOR: false,

    isLoadingMBSave: false,
    isLoadingMBFinish: false,
    showConfirmationMB: false,

    isLoadingPCTSave: false,
    isLoadingPCTFinish: false,
    showConfirmationPCT: false,

    isLoadingPMSave: false,
    isLoadingPMFinish: false,
    showConfirmationPM: false,

    showConfirmationNewValidation: false,
    isLoadingNewValidation: false,
  }),
  props: {
    value: Boolean,
  },
  async mounted() {
    await this.setValidations();
  },
  computed: {
    ...mapState("material", ["materialSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("material", [
      "getValidationsByMaterial",
      "getValidation",
      "updateValidation",
      "newValidation",
    ]),
    ...mapMutations("material", ["SET_RAW_MATERIAL"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.SET_RAW_MATERIAL(null);
      this.show = false;
    },
    // Form validations
    validation(name, type) {
      if (type === "F") {
        return requiredFValidation(name);
      } else {
        return requiredValidation(name);
      }
    },
    validationNumberMin() {
      return numberValidation({ min: 0 });
    },
    getStatus(currentStatus) {
      let status = {
        DISCARD: "Descartado",
        NOT_STARTED: "No iniciado",
        OR: "Características organolépticas",
        MB: "Análisis microbiológicos",
        PCT: "Análisis Fisicoquímicos",
        MP: "Conformidad y Aceptación de MP",
        END: "Finalizado",
      };
      return status[currentStatus];
    },
    async setValidations() {
      try {
        this.isLoading = true;
        let response = await this.getValidationsByMaterial({
          materialId: this.materialSelected._id,
        });
        if (!response) throw response;
        this.validations = response.validations;
        let index = response.validations.length - 1;
        this.validationSelected = response.validations[index];
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar validaciones`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoading = false;
    },
    async saveDate() {
      if (this.$refs.formDate.validate()) {
        try {
          this.isSaving = true;
          let payload = {
            analysisQualityDate: this.validationUpdate.analysisQualityDate,
            validationId: this.validationUpdate._id,
            status: "OR",
            isReadyToValidate: true,
          };
          let response = await this.updateValidation(payload);
          if (!response) throw response;
          this.validationUpdate = response.validationFound;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Información guardada`,
            timeout: 4000,
          });
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isSaving = false;
      }
    },
    async saveORData() {
      try {
        this.isLoadingORSave = true;
        let payload = {
          validationId: this.validationUpdate._id,
          isForeignMatter: this.validationUpdate.isForeignMatter,
          appearance: this.validationUpdate.appearance,
          color: this.validationUpdate.color,
          smell: this.validationUpdate.smell,
          texture: this.validationUpdate.texture,
          successfulOrganolepticCharacteristics:
            this.validationUpdate.successfulOrganolepticCharacteristics,
        };
        let response = await this.updateValidation(payload);
        if (!response) throw response;
        this.validationUpdate = response.validationFound;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: `Información guardada`,
          timeout: 4000,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoadingORSave = false;
    },
    async finishORData() {
      if (this.$refs.formOrganolepticCharacteristics.validate()) {
        try {
          this.isLoadinfORFinish = true;
          let payload = {
            validationId: this.validationUpdate._id,
            isForeignMatter: this.validationUpdate.isForeignMatter.value,
            appearance: this.validationUpdate.appearance,
            color: this.validationUpdate.color,
            smell: this.validationUpdate.smell,
            texture: this.validationUpdate.texture,
            successfulOrganolepticCharacteristics:
              this.validationUpdate.successfulOrganolepticCharacteristics,
            isReadyOR:
              this.validationUpdate.successfulOrganolepticCharacteristics.value,
            status: this.validationUpdate.successfulOrganolepticCharacteristics
              .value
              ? "MB"
              : "DISCARD",
          };
          let response = await this.updateValidation(payload);
          if (!response) throw response;
          this.validationUpdate = response.validationFound;
          this.panels = 1;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Características organolépticas validado`,
            timeout: 4000,
          });
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoadinfORFinish = false;
      }
    },
    async saveMBData() {
      try {
        this.isLoadingMBSave = true;
        let payload = {
          validationId: this.validationUpdate._id,
          fungiAndYeast: this.validationUpdate.fungiAndYeast,
          coliforms: this.validationUpdate.coliforms,
          facultativeAerobes: this.validationUpdate.facultativeAerobes,
          successfulMicrobiologicalAnalysis:
            this.validationUpdate.successfulMicrobiologicalAnalysis,
          microbiologicalObservations:
            this.validationUpdate.microbiologicalObservations,
        };
        let response = await this.updateValidation(payload);
        if (!response) throw response;
        this.validationUpdate = response.validationFound;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: `Información guardada`,
          timeout: 4000,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoadingMBSave = false;
    },
    async finishMBData() {
      if (this.$refs.formMicrobiologicalAnalysis.validate()) {
        try {
          this.isLoadingMBFinish = true;
          let payload = {
            validationId: this.validationUpdate._id,
            fungiAndYeast: this.validationUpdate.fungiAndYeast,
            coliforms: this.validationUpdate.coliforms,
            facultativeAerobes: this.validationUpdate.facultativeAerobes,
            successfulMicrobiologicalAnalysis:
              this.validationUpdate.successfulMicrobiologicalAnalysis,
            microbiologicalObservations:
              this.validationUpdate.microbiologicalObservations,
            isReadyMB:
              this.validationUpdate.successfulMicrobiologicalAnalysis.value,
            status: this.validationUpdate.successfulMicrobiologicalAnalysis
              .value
              ? "PCT"
              : "DISCARD",
          };
          let response = await this.updateValidation(payload);
          if (!response) throw response;
          this.validationUpdate = response.validationFound;
          this.panels = 2;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Análisis microbiológico validado`,
            timeout: 4000,
          });
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoadingMBFinish = false;
      }
    },
    async savePCTData() {
      try {
        this.isLoadingPCTSave = true;
        let payload = {
          validationId: this.validationUpdate._id,
          density: this.validationUpdate.density,
          viscosity: this.validationUpdate.viscosity,
          ph: this.validationUpdate.ph,
          particleSize: this.validationUpdate.particleSize,
          physicochemicalObservations:
            this.validationUpdate.physicochemicalObservations,
          successfulPhysicochemicalAnalysis:
            this.validationUpdate.successfulPhysicochemicalAnalysis,
        };
        let response = await this.updateValidation(payload);
        if (!response) throw response;
        this.validationUpdate = response.validationFound;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: `Información guardada`,
          timeout: 4000,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoadingPCTSave = false;
    },
    async finishPCTData() {
      if (this.$refs.formPhysicochemicalAnalysis.validate()) {
        try {
          this.isLoadingPCTFinish = true;
          let payload = {
            validationId: this.validationUpdate._id,
            density: this.validationUpdate.density,
            viscosity: this.validationUpdate.viscosity,
            ph: this.validationUpdate.ph,
            particleSize: this.validationUpdate.particleSize,
            physicochemicalObservations:
              this.validationUpdate.physicochemicalObservations,
            successfulPhysicochemicalAnalysis:
              this.validationUpdate.successfulPhysicochemicalAnalysis,
            isReadyPCT:
              this.validationUpdate.successfulPhysicochemicalAnalysis.value,
            status: this.validationUpdate.successfulPhysicochemicalAnalysis
              .value
              ? "MP"
              : "DISCARD",
          };
          let response = await this.updateValidation(payload);
          if (!response) throw response;
          this.validationUpdate = response.validationFound;
          this.panels = 3;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Información guardada`,
            timeout: 4000,
          });
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoadingPCTFinish = false;
      }
    },
    async savePMData() {
      try {
        this.isLoadingPMSave = true;
        let payload = {
          validationId: this.validationUpdate._id,
          successfulMaterialQuality:
            this.validationUpdate.successfulMaterialQuality,
          successfulMaterialStock:
            this.validationUpdate.successfulMaterialStock,
          observations: this.validationUpdate.observations,
        };
        let response = await this.updateValidation(payload);
        if (!response) throw response;
        this.validationUpdate = response.validationFound;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: `Información guardada`,
          timeout: 4000,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoadingPMSave = false;
    },
    async finishPMData() {
      if (this.$refs.formPMComplianceAcceptance.validate()) {
        try {
          this.isLoadingPMFinish = true;
          let payload = {
            validationId: this.validationUpdate._id,
            successfulMaterialQuality:
              this.validationUpdate.successfulMaterialQuality,
            successfulMaterialStock:
              this.validationUpdate.successfulMaterialStock,
            observations: this.validationUpdate.observations,
            isReadyPM: this.validationUpdate.successfulMaterialStock.value,
            status:
              this.validationUpdate.successfulMaterialQuality.value &&
              this.validationUpdate.successfulMaterialStock.value
                ? "END"
                : "DISCARD",
          };
          let response = await this.updateValidation(payload);
          if (!response) throw response;
          this.validationUpdate = response.validationFound;
          this.panels = null;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Información guardada`,
            timeout: 4000,
          });
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoadingPMFinish = false;
      }
    },
    async generateNewValidation() {
      if (this.$refs.formPMComplianceAcceptance.validate()) {
        try {
          this.isLoadingPMFinish = true;
          let payload = {
            validationId: this.validationUpdate._id,
            successfulMaterialQuality:
              this.validationUpdate.successfulMaterialQuality,
            successfulMaterialStock:
              this.validationUpdate.successfulMaterialStock,
            observations: this.validationUpdate.observations,
            isReadyPM: this.validationUpdate.successfulMaterialStock.value,
            status: "END",
          };
          let response = await this.newValidation(payload);
          if (!response) throw response;
          await this.setValidations();
          this.panels = null;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Nueva validación creada`,
            timeout: 4000,
          });
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al crear validación`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoadingPMFinish = false;
      }
    },
  },
  watch: {
    async validationSelected(value) {
      if (value) {
        try {
          this.loadValidation = true;
          let response = await this.getValidation({
            validationId: value.value,
          });
          if (!response) throw response;
          this.validationUpdate = response.validationFound;
          if (this.validationUpdate.status == "OR") {
            this.panels = 0;
          } else if (this.validationUpdate.status == "MB") {
            this.panels = 1;
          } else if (this.validationUpdate.status == "PCT") {
            this.panels = 2;
          } else if (this.validationUpdate.status == "MP") {
            this.panels = 3;
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar validacion`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.loadValidation = false;
      } else {
        this.validationUpdate = null;
      }
    },
  },
};
</script>
